import { render, staticRenderFns } from "./DriverWiseStudentsPrint.vue?vue&type=template&id=248b9ecb&scoped=true&"
import script from "./DriverWiseStudentsPrint.vue?vue&type=script&lang=js&"
export * from "./DriverWiseStudentsPrint.vue?vue&type=script&lang=js&"
import style0 from "./DriverWiseStudentsPrint.vue?vue&type=style&index=0&id=248b9ecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b9ecb",
  null
  
)

export default component.exports